import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import * as $ from 'jquery';
import { InsuranceService } from '../Services/insurance-service.service';
import { RootResponse, GenericResponse } from '../Models/TravelInsuranceProperties';
import { window } from 'rxjs/operators';
import { Router } from '@angular/router';
import { Route } from '@angular/compiler/src/core';
import { PassengerInfoService } from '../Services/passengerInfo.service';
import { Countries } from '../Models/Countries';
import { ChildAgeProps, InfantAgeProps } from '../Models/FlightSearchProperties';
import { AirlineMasterService } from '../Services/airline-master.service';
import { AirlineMasterProperties } from '../Models/AirlineMasterProperties';

@Component({
  selector: 'app-travel-insurance-issuance',
  templateUrl: './travel-insurance-issuance.component.html',
  styleUrls: ['./travel-insurance-issuance.component.css']
})
export class TravelInsuranceIssuanceComponent implements OnInit {

  constructor(private airlineservice: AirlineMasterService, private router: Router, private userService: PassengerInfoService, private insuranceService: InsuranceService) { }
  @ViewChild('insureOnewayForm', null) insureOnewayForm: NgForm;
  @ViewChild('insureRoundTripForm', null) insureRoundTripForm: NgForm;
  airlineMasterinfo: AirlineMasterProperties[] = [];
  ngOnInit() {
    //$('[data-toggle="tooltip"]').tooltip();
    //setTimeout(() => { 
    //this.insureOnewayForm.controls["adultow"].setValue(1);
    //this.insureOnewayForm.controls["childow"].setValue(0);
    //this.insureOnewayForm.controls["infantow"].setValue(0);
    //  this.insureRoundTripForm.controls["adultrt"].setValue(1);
    //  this.insureRoundTripForm.controls["childrt"].setValue(0);
    //  this.insureRoundTripForm.controls["infantrt"].setValue(0);
    //});fv
    this.getCountries();
    this.getCountriesWithCities();
    this.AddPassengerList();
    this.GetAirlineData();
    const today = new Date();
    this.minDate = today.toISOString().split('T')[0];
  }
  minDate: string;
  adultList = [
    { adultItem: 1 },
    { adultItem: 2 },
    { adultItem: 3 },
    { adultItem: 4 },
    { adultItem: 5 },
    { adultItem: 6 },
    { adultItem: 7 },
    { adultItem: 8 },
    { adultItem: 9 },
  ];
  InfantItem = [
    { label: '0', value: 0 },
    { label: '1', value: 1 },
    { label: '2', value: 2 },
    { label: '3', value: 3 },
    { label: '4', value: 4 },
    { label: '5', value: 5 },
    { label: '6', value: 6 },
    { label: '7', value: 7 }
  ];
    ChildItem = [
      { label: '0', value: 0 },
      { label: '1', value: 1 },
      { label: '2', value: 2 },
      { label: '3', value: 3 },
      { label: '4', value: 4 },
      { label: '5', value: 5 },
      { label: '6', value: 6 },
      { label: '7', value: 7 }
    ];
  childList: Number[] = [];
  infantList: Number[] = [];
  adultCountOW: number = 1;
  adultCountRT: number = 1;
  childCountOW: number = 0;
  childCountRT: number = 0;
  infantCountOW: number = 0;
  infantCountRT: number = 0;
  errorMessage: string | null = null;
  locationType: 'country' | 'city' = 'country';
  countryList: Countries[] = [];
  countryCityList: Countries[] = [];
  returndate: boolean = false;
  tripType: string = 'oneway';
  AddPassengerList() {
    for (let i = 0; i <= 8; i++) {
      let childItme = new Number();
      childItme = Number(i);
      this.childList.push(childItme);
    }
    //for (let i = 0; i <= 1; i++) {
    //  let infantItem = new Number();
    //  infantItem = Number(i);
    //  this.infantList.push(infantItem);
    //}
  }
  ChangeOnewayAdult(value: number) {
    try {
      let count = 9 - value;
      if (count >= 0) {
        this.childList = [];
        if ((value + this.childCountOW) > 9) {
          this.childCountOW = this.childList.length;
          this.ChangeOnewayChildAge(this.childCountOW);
        };
        for (let i = 0; i <= count; i++) {
          let childItme = new Number();
          childItme = Number(i);
          this.childList.push(childItme);
        }

      }
      else {
        for (let i = 0; i <= 9; i++) {
          let childItme = new Number();
          childItme = Number(i);
          this.childList.push(childItme);
        }
      }

      if (value >= 0) {
        this.infantList = [];
        this.infantCountOW = 0;
        for (let i = 0; i < value + 1; i++) {
          let infantItem = new Number();
          infantItem = Number(i);
          this.infantList.push(infantItem);
        }
        this.ChangeOnewayInfantAge(this.infantCountOW);
      }
      else if (value == null || value == undefined) {
        this.infantCountOW = 0;
        this.infantList = [0];
        this.ChangeOnewayInfantAge(this.infantCountOW);
      }

      else {
        for (let i = 0; i <= 1; i++) {
          let infantItem = new Number();
          infantItem = Number(i);
          this.infantList.push(infantItem);
        }
      }
    }
    catch (e) {
    }
  }
  childAgeObj = new ChildAgeProps();
  infantAgeObj = new InfantAgeProps();
  childAgeListOf: ChildAgeProps[] = [];
  infantAgeListOf: InfantAgeProps[] = [];
  childAgeItem: number = 0;
  childAgeValue: number;
  infantAgeValue: string;
  ChangeOnewayChildAge(value: number) {
    try {
      if (value != 0) {
        this.childAgeListOf.splice(0, this.childAgeListOf.length);
        for (let p = 0; p < value; p++) {
          this.childAgeObj = new ChildAgeProps();
          this.childAgeObj.childAge = this.childAgeValue;
          this.childAgeListOf.push(this.childAgeObj);
        }
      }
      else {
        this.childAgeListOf.splice(0, this.childAgeListOf.length);
      }

    }
    catch (ex) {
      console.log(ex);
    }

  }
  AirlineCode: string[] = [];
  GetAirlineData() {
    this.airlineservice.getAirlinesData().subscribe((data) => {
      if (data.length > 0) {

        this.airlineMasterinfo = data;
        this.airlineMasterinfo.forEach(item => {
          this.AirlineCode.push(item.airlinePrefixCode)
        });
      }
    })
  }
  ChangeOnewayInfantAge(infValue: number) {
    try {
      if (infValue != 0) {

        this.infantAgeListOf.splice(0, this.infantAgeListOf.length);
        for (let p = 0; p < infValue; p++) {
          this.infantAgeObj = new InfantAgeProps();
          this.infantAgeObj.infantAge = this.infantAgeValue;
          this.infantAgeListOf.push(this.infantAgeObj);
        }
      }
      else {
        this.infantAgeListOf.splice(0, this.infantAgeListOf.length);
      }
    }
    catch (ex) {
      console.log(ex);
    }
  }
  genericRequest: any = { countryCode: "", totalAdults:0, totalChild: 0, totalInfants:0, departCountryCode:"", arrivalCountryCode:"",departDateTime: "",returnDateTime:"",departAirlineCode:"",requestType:"",fromCountryName:"",toCountryName:""};
  OnewayAvailability(rtForm: NgForm) {
    this.genericRequest.countryCode = rtForm.value.fromrt;
    //this.genericRequest.totalAdults = this.adultCountOW;
    //this.genericRequest.totalChild = this.childCountOW;
    //this.genericRequest.totalInfants = this.infantCountOW;
    this.genericRequest.totalAdults = this.adultCountRT;
    this.genericRequest.totalChild = this.childCountRT;
    this.genericRequest.totalInfants = this.infantCountRT;
    this.genericRequest.departCountryCode = rtForm.value.fromrt;
    this.genericRequest.arrivalCountryCode = rtForm.value.goingtort;
    this.genericRequest.fromCountryName = this.countryList.find(c => c.code === this.genericRequest.departCountryCode).countryName;
    this.genericRequest.toCountryName = this.countryList.find(c => c.code === this.genericRequest.arrivalCountryCode).countryName;

    this.genericRequest.departDateTime = rtForm.value.departuredatert;   
    this.genericRequest.returnDateTime = rtForm.value.departuredatert;
    //this.genericRequest.departAirlineCode = form.value.departAirlineCode.toUpperCase();
    this.genericRequest.requestType = "oneway";
    //let scrollableDiv = document.getElementById('resultsSection') as HTMLDivElement;
    //let bottomElement = scrollableDiv.lastElementChild;
    //bottomElement.scrollIntoView({ behavior: 'smooth', block: 'end' })
    this.insuranceService.CheckSupplierOnOff(localStorage.getItem("AgencyId")!)
      .subscribe({
        next: (supplierStatus: boolean) => {
          if (supplierStatus) {
            localStorage.setItem('TravelInsuranceRequestObj', JSON.stringify(this.genericRequest));
            this.router.navigate(['plans']);
          } else {
            alert("You don't have right to access this resource");
          }
        },
        error: (err) => {
          console.error('Error checking supplier status:', err);
          alert("Something went wrong while checking supplier access.");
        }
      });
  }
  RoundTripAvailability(rtForm: NgForm) {
    this.genericRequest.countryCode = rtForm.value.fromrt;
    this.genericRequest.totalAdults = this.adultCountRT;
    this.genericRequest.totalChild = this.childCountRT;
    this.genericRequest.totalInfants = this.infantCountRT;
    this.genericRequest.departCountryCode = rtForm.value.fromrt;
    this.genericRequest.arrivalCountryCode = rtForm.value.goingtort;
    this.genericRequest.departDateTime = rtForm.value.departuredatert;
    this.genericRequest.returnDateTime = rtForm.value.returndate;
    //this.genericRequest.departAirlineCode = rtForm.value.departureairlinecodert.toUpperCase();
    this.genericRequest.requestType = "roundtrip";
    this.insuranceService.CheckSupplierOnOff(localStorage.getItem("AgencyId")!)
      .subscribe({
        next: (supplierStatus: boolean) => {
          if (supplierStatus) {
            localStorage.setItem('TravelInsuranceRequestObj', JSON.stringify(this.genericRequest));
            this.router.navigate(['plans']);
          } else {
            this.errorMessage = "You don't have rights to access this resource.";
          }
        },
        error: (err) => {
          console.error('Error checking supplier status:', err);
          this.errorMessage = "Something went wrong while checking your supplier access. Please try again.";
        }
      });
  }
  toIssuance() {
    this.router.navigateByUrl('insurance-issuance');
  }
  ToDashboard() {
    this.router.navigateByUrl('zeusBookedPolicy');
  }
 
  checktriptype(trip: string) {
    if (trip == 'roundtrip') {
      this.returndate = true;
      this.tripType = 'roundtrip';
    }
    else if (trip == 'oneway') {
      this.returndate = false;
    }
  }
  onSubmit(form: NgForm) {
    if (!form.valid) {
      this.errorMessage = 'Please select required fields';
      return;
    }
    if (this.tripType === 'oneway') {
      this.OnewayAvailability(form);
    } else if (this.tripType === 'roundtrip') {
      this.RoundTripAvailability(form);
    }
  }
  getCountries() {
    try {
      this.userService.getCountries().subscribe((data) => {
        this.countryList = data;

      });
    }
    catch (e) {
      console.log(e);
    }
  }
  getCountriesWithCities() {
    this.userService
      .getCountriesWithCitiesForInsurance()
      .subscribe(
        (res) => {
          this.countryList = res.countries;
          this.countryCityList = res.countryCities;
        },
        (error) => {
          console.error(error);
        }
      );
  }
}
